<template lang="pug">
  .dashboard__table__content__item
    el-row.grid-content(:gutter="20" style="margin: 0")
      el-col(
        :span="5"
      )
        span.task-table__link( @click="viewTask(data)" ) {{ $t(data.task_name) }}
      el-col(
        :span="5"
      )
        span {{ $t(data.campaign_id) }}
      el-col(
        :span="5"
      )
        span {{ $t(data.campaign_name) }}
      el-col(
        v-if="type === 1"
        :span="5"
      )
        span {{ data.sub_final_scope_name || '—' }}
      el-col(
        :span="4"
      )
        span {{ data.start_date | dateFormatter }}
      el-col(
        v-if="type === 0"
        :span="4"
      )
        span {{ scope.row.end_date | dateFormatter }}
</template>

<script>
import { dateFormatter } from '@/umcc/util'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return null
      }
    },
    type: {
      type: Number,
      default () {
        return 1
      }
    }
  },
  filters: {
    dateFormatter
  }
}
</script>

<style lang="stylus">
.dashboard__table__content__item
  .task-table__link
    color $main
    cursor pointer
  .el-col
    height 48px
    display flex
    align-items center
  .el-row:hover
    background #f5f7fa
    > .el-col:nth-child(1)::before
      content: '';
      height: 100%;
      width: 3px;
      background-color: #4896e6;
      left: 0;
      top: 1px;
      position: absolute
</style>
